import React from 'react';
import './Projects.css';
import ProjectCard from '../../cards/project-card/project-card';
import { Project } from '../../../api/projectsApi';

interface ProjectsProps {
    projects: Project[];
    loading: boolean;
}

const Projects: React.FC<ProjectsProps> = ({ projects, loading }) => {
    return (
        <section id="projects" className="projects">
            <div className="container">
                <h2>Featured Projects</h2>
                {loading ? (
                    <div className="loading">
                        <div className="spinner"></div>
                        <p>Loading projects...</p>
                    </div>
                ) : (
                    <div className="projects-grid">
                        {projects.map((project) => (
                            <ProjectCard
                                key={project.id}
                                title={project.title}
                                description={project.description}
                                projectStatus={project.projectStatus}
                                projectUrl={project.projectUrl}
                                technologies={project.technologies}
                            />
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};

export default Projects;
